import { render, staticRenderFns } from "./DevicesList.vue?vue&type=template&id=19dedd2b&"
import script from "./DevicesList.vue?vue&type=script&lang=js&"
export * from "./DevicesList.vue?vue&type=script&lang=js&"
import style0 from "./DevicesList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports